import reactUpdate from 'immutability-helper';

import {DataTableActionType} from 'notebook/data-tables/DataTableReduxActions';
import {BenchlingAction} from 'redux-stores/Action';

import {DataTableErrorsByRecordId} from './DataTableConstants';

export interface DataTablesState {
  dataTableErrorsByRecordId: DataTableErrorsByRecordId;
}

const DATA_TABLES_INITIAL_STATE: DataTablesState = {
  dataTableErrorsByRecordId: {},
};

export default function reduceResults(
  state: DataTablesState = DATA_TABLES_INITIAL_STATE,
  action: BenchlingAction
): DataTablesState {
  switch (action.type) {
    case DataTableActionType.DATA_TABLES_VALIDATION_STATUS_FETCH_COMPLETED: {
      const {errorsByRecordId} = action;
      return reactUpdate(state, {
        dataTableErrorsByRecordId: {$merge: errorsByRecordId},
      });
    }
    default:
      return state;
  }
}
